/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Hero_LedeInputs */

const en_help_hero_lede = /** @type {(inputs: Help_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short answers on booking, training, your diet and your account, written by the people who build the app.`)
};

const pl_help_hero_lede = /** @type {(inputs: Help_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krótkie odpowiedzi o rezerwacjach, treningu, diecie i koncie, napisane przez ludzi, którzy tworzą aplikację.`)
};

/**
* | output |
* | --- |
* | "Short answers on booking, training, your diet and your account, written by the people who build the app." |
*
* @param {Help_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_hero_lede = /** @type {((inputs?: Help_Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_hero_lede(inputs)
	return en_help_hero_lede(inputs)
});